import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class AuthenticateUserService {

    private baseUrl: string = '../rest/user/authenticated';
    constructor (
        private http: Http
    ) {}

    get() {
        return this.http.get(`${this.baseUrl}`)
            .map((res:any) => res.json());
    }

}


// WEBPACK FOOTER //
// ./public/upgrade/core/authenticate-user.service.ts